import React from 'react';
import { useAgencyDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/AgencyDashboard/store/agencyDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const LeadTimeBeforeShiftStartChart: React.FC = () => {
  const data = useAgencyDashboardStore((s) => s.leadTime);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return (
      <EmptyStateContainer>
        No agency lead time data available for the selected filters.
      </EmptyStateContainer>
    );
  }

  const getBarColor = (key: string): string => {
    if (key === 'under_4h') return palette.indicator.negative;
    if (key === '4_to_12h') return palette.threshold.attention;
    return palette.chartColors[3] || palette.chartColors[0];
  };

  const items: HorizontalBarItem[] = data.map((d) => {
    const count = d.count.toLocaleString();
    const percentage = formatDashboardNumber(d.percentage);
    return {
      label: d.label,
      value: d.count,
      valueLabel: `${count} (${percentage}%)`,
      ariaLabel: `${d.label}: ${count} shifts, ${percentage} percent`,
      tooltipHtml: `<strong>${d.label}</strong><br/>Shifts: ${count}<br/>Share: ${percentage}%`,
      barColor: getBarColor(d.key),
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      leftMargin={150}
      rightMargin={110}
      ariaLabel="Lead time before shift start when agency requested, showing shift count and share per lead time bucket"
    />
  );
};
